import { createHash } from "crypto";
import stringify from "json-stable-stringify";
export function createSourceTextSpan(parts) {
    const hash = createHash("sha256");
    hash.update(`${stringify(parts)}`);
    const id = hash.digest("hex");
    return {
        ...parts,
        id,
    };
}
//# sourceMappingURL=helpers.js.map